import React, { useEffect, useMemo } from "react";
import { connect } from "react-redux";
import Router from "../../routes";
import { actions } from "../../store/reducers/authentication";
import Loading from "../../components/Loading";
import { isMobileOnly, isIOS, isIPhone13, isIOS13 } from 'react-device-detect';
import compareVer from '../../helpers/compareVer';
import packageJson from '../../../package.json';
import { useLocation } from "react-router";
import useQuery from "../../helpers/useQuery";
import { changeLanguage } from "../../helpers/Language";
import OnlyDesktop from "../OnlyDesktop";
global.appVersion = packageJson.version;

const supportedPathNames = ['register', 'confirm'];

const storageListener = (e) => {
  const { key, newValue, oldValue } = e;

  if (key === 'previous' || (key === 'token' && !newValue && oldValue) || ((key === 'token' && newValue && !oldValue))) {
    window.location.href = '/';
    return;
  }

  if (key === 'project' || key === 'source') {
    window.location.reload();
    return;
  }
}

function Root({ checking, check }) {
  const { pathname } = useLocation();
  const params = useQuery();
  const _continue = useMemo(() => ['/app-redirect'].includes(pathname), [pathname]);

  useEffect(() => {
    window.addEventListener("storage", storageListener);
    return () => {
      window.removeEventListener('storage', storageListener);
    };
  }, []);

  useEffect(() => {
    if (params.has('language')) {
      const lang = params.get('language');
      if (lang === 'en' || lang === 'fr') {
        changeLanguage(lang);
      }
    }
  }, []);

  useEffect(() => {
    fetch('/meta.json')
      .then(res => res.json())
      .then(meta => {
        const latest = meta.version;
        const current = global.appVersion;
        const shouldClear = compareVer(latest, current);
        if (shouldClear) {
          refreshCacheAndReload();
        }
      });
  }, []);

  useEffect(() => {
    if (!['/app-redirect'].includes(pathname)) {
      check(pathname);
    }
  }, [check]);

  const iOS = () => {
    return ([
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)) ? true : false;
  }

  const isSupportedMobile = useMemo(() => {
    let isSupported = false;

    supportedPathNames.forEach(path => {
      if (pathname.includes(path));
      isSupported = true;
    });

    if (pathname === '/' || isSupported) {
      return true;
    }
    return !(isMobileOnly || isIOS || isIOS13 || isIPhone13 || iOS());
  }, [pathname]);

  const refreshCacheAndReload = () => {
    if (caches) {
      caches.keys().then((names) => {
        for (const name of names) {
          caches.delete(name);
        }
      })
    }
    window.location.reload(true);
  };

  // const Router = lazy(() => isMobile ? <div /> : import("../../routes"));
  return (!isSupportedMobile ? <OnlyDesktop /> : ((checking && !_continue) ? <Loading /> : <Router />))
}

export default connect(
  ({ authentication }) => (authentication),
  actions
)(Root);
